var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerticalAlignCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22165_13407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21 19H11V22C11 22.55 11.45 23 12 23C12.55 23 13 22.55 13 22V19H14.79C15.24 19 15.46 18.46 15.14 18.15L12.35 15.36C12.15 15.16 11.84 15.16 11.64 15.36L8.85 18.15C8.54 18.46 8.76 19 9.21 19ZM14.79 5H13V2C13 1.45 12.55 1 12 1C11.45 1 11 1.45 11 2V5H9.21C8.76 5 8.54 5.54 8.85 5.85L11.64 8.64C11.84 8.84 12.15 8.84 12.35 8.64L15.14 5.85C15.46 5.54 15.24 5 14.79 5ZM4 12C4 12.55 4.45 13 5 13H19C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11H5C4.45 11 4 11.45 4 12Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22165_13407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalAlignCenter);
export default __webpack_public_path__ + "static/media/vertical_align_center.d501bd4f1860b8bfdb57418f1df0e8c8.svg";
export { ForwardRef as ReactComponent };